import React from 'react';
import { Card, Typography, Box, Button, Stack, Tooltip, useTheme } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { createFormUrlQuery } from '@/utils/constants';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDispatch } from 'react-redux';
import { showToast } from '@/features/toast/toastSlice';
import LinkIcon from '@mui/icons-material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from '@mui/icons-material/Download';

export const FormCard = ({ form }) => {
	const theme = useTheme();

	const { clientRow, broker, dealRow, claim } = useObjectContext();

	const dispatch = useDispatch();
	const isTemplate = form?.template === true;

	const formUrl = createFormUrlQuery({
		broker: broker?.name,
		insured: clientRow?.name,
		firstName: clientRow?.contactFirstName,
		lastName: clientRow?.contactLastName,
		deal: dealRow?.dealId,
		client: clientRow?.clientId,
		policyNumber: claim?.PolicyNumber,
	});

	const queryUrl = `${form.url}${formUrl}`;

	const handleOpenInNewTab = () => {
		window.open(queryUrl, '_blank', 'noopener,noreferrer');
	};

	const handleDownloadTemplate = () => {
		const baseUrl = form.url.replace('web=1', 'download=1');
		const downloadUrl = baseUrl.includes('download=1')
			? baseUrl
			: `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}download=1`;
		window.open(downloadUrl, '_blank', 'noopener,noreferrer');
	};

	const handleOpenTemplate = () => {
		window.open(form.url, '_blank', 'noopener,noreferrer');
	};

	return (
		<Card
			elevation={theme.palette.mode === 'dark' ? 0 : 1}
			sx={{
				p: '1em',
				...(theme.palette.mode === 'dark' && {
					border: `1px solid ${theme.palette.divider}`,
				}),
			}}
		>
			<Box
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '10px',
					marginLeft: '2px',
				}}
			>
				<Typography variant='task_body' style={{ display: 'flex', alignItems: 'center' }}>
					<span style={{ fontWeight: 'bold' }}>{form.name}</span>
					<span style={{ margin: '0 0.5em' }}>{' | '}</span>
					<span style={{ color: '#505AFC' }}>{`Version ${form.version}`}</span>
				</Typography>
				{isTemplate ? (
					<Stack direction='row' spacing={1.5}>
						<Tooltip title={'Download template'}>
							<Button
								sx={{ borderRadius: '10px' }}
								variant='tab_header'
								startIcon={<DownloadIcon />}
								onClick={handleDownloadTemplate}
								disabled={!form?.url}
							>
								{'DOWNLOAD'}
							</Button>
						</Tooltip>

						<Tooltip title={'Open SharePoint template'}>
							<span>
								<Button
									sx={{ borderRadius: '10px' }}
									variant='tab_header'
									startIcon={<OpenInNewIcon />}
									onClick={handleOpenTemplate}
									disabled={!form?.url}
								>
									{'OPEN IN NEW TAB'}
								</Button>
							</span>
						</Tooltip>
					</Stack>
				) : (
					<Stack direction='row' spacing={1.5}>
						<CopyToClipboard
							text={queryUrl}
							onCopy={() => {
								if (queryUrl) {
									dispatch(
										showToast({
											message: 'Copied Form link!',
											success: true,
										}),
									);
								}
							}}
						>
							<Tooltip title={'Copy form link to clipboard'}>
								<span>
									<Button
										sx={{ borderRadius: '10px' }}
										variant='tab_header'
										startIcon={<LinkIcon />}
									>
										{'Form Link'}
									</Button>
								</span>
							</Tooltip>
						</CopyToClipboard>

						<Tooltip title={'Open form in new tab'}>
							<Button
								sx={{ borderRadius: '10px' }}
								variant='tab_header'
								onClick={handleOpenInNewTab}
								startIcon={<OpenInNewIcon />}
							>
								{'OPEN IN NEW TAB'}
							</Button>
						</Tooltip>
					</Stack>
				)}
			</Box>
			<div style={{ paddingLeft: '2px' }}>
				<Typography variant='task_body'>{form.description}</Typography>
			</div>
		</Card>
	);
};
